import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useState } from "react";

function ContactForm(){
    const [error, setError]= useState(null);
    const [loading, setLoading]= useState(false)
    const [name, setName]= useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit= async (e)=>{
        e.preventDefault();
        setLoading(true);
        if(name==="" || email==="" || message===""){
            setError("All field must be filled.");
            setLoading(false);
            return;
        }
        try {
           await axios.post(
              process.env.REACT_APP_API_BE_URL + "/api/v1/contact/mail",
              {
                name: name,
                email: email,
                message: message,
              },
              {
                mode: "no-cors",
                headers: {
                  "Access-Control-Allow-Origin": "*",
                  "Content-Type": "application/json",
                }
              }
            );
            //Throws error if status is outside 2xx
            setError("Thank you for contacting me, I'll get back ASAP.");
            setLoading(false);
        } catch (err) {
            if (err.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              setError(err.response.data.info);
              setLoading(false);
            }else{
                setError("An error occured, Try again.");
                setLoading(false);
            }
        }
    }

    return(
        <div className="contact_form">
            <form>
                <div className="half field">
                    <label htmlFor="name">Your Name</label>
                    <input type="text" id="name" onChange={(e)=> setName(e.target.value)} value={name} />
                </div>
                <div className="half field">
                    <label htmlFor="email">Your Email</label>
                    <input type="email" id="email" onChange={(e)=> setEmail(e.target.value)} value={email} />
                </div>
                <div className="field">
                    <label htmlFor="message">Message</label>
                    <textarea rows="10" onChange={(e)=> setMessage(e.target.value)} value={message}></textarea>
                </div>
                { error !== null && (
                    <div className={ error=== "Thank you for contacting me, I'll get back ASAP." ? "field success" : "field error"}>
                        <span>{error}</span>
                    </div>
                )}
                <div className="field">
                    <button type="submit" onClick={handleSubmit} disabled={loading}>{loading ? (<FontAwesomeIcon icon={faSpinner} />) : "Send Message"}</button>
                </div>
            </form>
        </div>
    );
}

export default ContactForm;